import { ContentType } from '../../domain/types';

export const transformToLabel = (contentType: ContentType) => contentType.replace('_', ' ').toLowerCase();
